import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelAssigningComponent } from './panel-assigning.component';
import { FeedbackModalComponent } from './feedback-modal/feedback-modal.component';
import { CandidateDetailsModalComponent } from './candidate-details-modal/candidate-details-modal.component';
import { MaterialModule } from 'src/app/material/material.module';
import { PanelService } from 'src/app/shared/panel-service/panel.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { NgxSpinnerModule } from "ngx-spinner";



@NgModule({
  declarations: [
    PanelAssigningComponent,
    FeedbackModalComponent,
    CandidateDetailsModalComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    NgxSpinnerModule
  ],
  providers: [
    PanelService,
    NotificationService
  ],
  entryComponents: [PanelAssigningComponent, FeedbackModalComponent, CandidateDetailsModalComponent]
})
export class PanelAssigningModule { }
